import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../../util/theme';

const CtaBarSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  text-align: center;

  h3 {
    color: ${getColor('accentGreen')};
    font-size: 2.5rem;
    text-transform: uppercase;
  }

  p {
    color: ${getColor('white')};
    font-size: 24px;
  }
`;

export default CtaBarSuccessWrapper;
